import { render, staticRenderFns } from "./SelectSchool.vue?vue&type=template&id=e56f2c94&scoped=true&"
import script from "./SelectSchool.vue?vue&type=script&lang=js&"
export * from "./SelectSchool.vue?vue&type=script&lang=js&"
import style0 from "./SelectSchool.vue?vue&type=style&index=0&id=e56f2c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56f2c94",
  null
  
)

export default component.exports